import { Component, Input } from '@angular/core';
import { SearchTagType } from '../../models/models';

@Component({
    selector: 'tagtype-tag',
    templateUrl: './tagtype-tag.component.html',
    standalone: false
})
export class TagTypeTag {
    @Input() tag: SearchTagType = {} as SearchTagType;

    constructor() {
    }
}
